export const cladifyProposal = {
  project_info : {
    name: {
      label: 'Project Name',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: 'Fram & Slokker'
    },
    address: {
      label: 'Project Address',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: '55 Port Street, Mississauga, ON'
    },
    sales_person: {
      label: 'Sales Person',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: {
        'From': 'Kevin Monsour',
        'Phone': '+1 888.222.222',
        'Mobile': '(416)999-999',
        'Email': 'email@email.com',
        'Estimator': 'Neda Emam'
      }
    },
    contact: {
      label: 'Proposal Contact',
      f_component: 'VSelect',
      d_component: 'VContactTable',
      bind: {
        itemText: 'Name',
        options: [
          {
            'To': 'Contact 1',
            'Name': '',
            'Phone': '416.222.222',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
          {
            'To': 'Contact 2',
            'Name': '',
            'Phone': '416.222.221',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
        ]
      },
      value: {
        'To': '',
        'Name': '',
        'Phone': '',
        'Email': '',
        'Quote No.': ''
      }
    },
    date: {
      label: 'Proposal Date',
      f_component: 'VDatePicker',
      d_component: null,
      value: null
    },
    cover_photo: {
      label: 'Proposal Cover Photo',
      f_component: 'VDropZone',
      d_component: null,
      value: {
        file: '',
        name: '',
        url: ''
      }
    },
    pricing: {
      rfq_id: null
    }
  },
  proposal_info: [
    {
      id: 'supply_install',
      label: 'Supply and/or Install',
      f_component: 'VMultiCheckbox',
      d_component: 'custom',
      bind: {
        options: ['supply', 'install']
      },
      value: ['supply', 'install']
    },
    {
      id: 'quote_details',
      label: 'Quote Details',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      bind: {
        placeholder: 'Enter quote details'
      },
      value: `<span>Our Scope of Work is as follows:</span>
              <ul>
                <li>{TOTAL_CLADDING_SQFT} SQFT and {TOTAL_CLADDING_LFT} LFT of Cladify Cladding.</li>
              </ul>`
    },
    {
      id: 'documents',
      label: 'Documents',
      f_component: 'VDynamicList',
      d_component: 'VDocTable',
      bind: {
        rowTemplate: [
          { 
            label: 'name',
            component: 'VTextField',
            bind: {},
            default: ''
          },
          { 
            label: 'received_on',
            component: 'VDatepicker',
            bind: {},
            default: null 
          },
          {
            label: 'details',
            component: 'VTextField',
            bind: {
              placeholder: "Enter other details for document"
            },
            default: ''
          }
        ],
        isColumn: true
      },
      value: []
    },
    {
      id: 'document_details',
      label: 'Document Details',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      bind: {
        placeholder: 'Enter document details'
      },
      value: ''
    },
    {
      id: 'system',
      label: 'System',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li><mark>Rainscreen Cladding System</mark>
                  <ul>
                    {INSTALLATION_METHODS_LIST}
                    <li>Joint per standard system detail 1/2" with +-¼” tolerance</li>
                    <li>Reveal joint filler same colour as panels</li>
                  </ul>
                </li>
              </ul>`
    },
    {
      id: 'pmf',
      label: 'Products, Materials & Finishes',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<h3>Products</h3>
              <p>
                Cladify has been perfecting the art and science of cladding for over 
                20 years. Our core technologies are used as the foundation for all of our solutions; 
                the technology allows for multi-facing material options such as natural stone, 
                brick, porcelain, Metal (PVDF), nano glass, glass, and solar BIPV without 
                any restrictions on facade choices. Cladify panels are designed to lower 
                costs, improve building performance, and increase design and application 
                versatility.
              </p>
              {PMF}`
    },
    {
      id: 'installation_materials',
      label: 'Installation Materials Components/ Accessories',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li>Flashing:
                  <ul>
                    <li><mark>24-gauge single side prepainted - galvanized steel cold bended sheets</mark></li>
                  </ul>
                </li>
                <li>Aluminum Profiles / Trims:
                  <ul>
                    <li><mark>1mm 3003 prefabricated aluminum sheet/ paint as per standard PPG colors</mark></li>
                  </ul>
                </li>
                <li>Air/Water Barrier:
                  <ul>
                    <li><mark>Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance</mark></li>
                    <li><mark>Henry Blueskin VP160 -Self-Adhered Water Resistive Air Barrier</mark></li>
                  </ul>
                </li>
                <li>Caulking: 
                  <ul>
                    <li><mark>DOWSIL contractors weatherproofing / colors as per manufacturer</mark></li>
                  </ul>
                </li>
                <li>Insulation: 
                  <ul>
                    <li><mark>2" Rockwool Cavityrock - Exterior Insulation for Cavity Wall and Rainscreen Applications</mark></li>
                    <li><mark>2" Rockwool Comfortboard 80 - Thermal Insulated Sheathing</mark></li>
                  </ul>
                </li>
                <li>System subframing:
                  <ul>
                    <li><mark>Adjustable thermally broken bracket system - max adjustability 2"</mark></li>
                    <li><mark>16 gauge galvanised steel vertical L-Angles - max system depth 4"</mark></li>
                    <li><mark>1" Interlocking channel system extrusion based on Alloy 6063 T6, Mill finished</mark></li>
                  </ul>
                </li>
              </ul>
              <small>**General detail - Installation materials. System details and wall assembly components will be finalized during the shop drawing phase.</small>`
    },
    {
      id: 'project_scope',
      label: 'Inclusions',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li><mark>Supply and Install</mark> of Cladify panels and associate mounting accessories as per highlighted areas on drawings.</li>
                <li>{INSTALLATION_METHODS_TEXT} and associated fastening accessories.</li>
                <li><mark>Supply and install</mark> of insulation 2" Rockwool Cavityrock - Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.</li>
                <li><mark>Supply and install</mark> of AWB Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.</li>
                <li>Prefabricated panel system - Cut-to-size fabrication will be fabricated in the factory.</li> 
                <li>Field applied caulking/sealant with backer rod between Cladify panels/panel to panel joints only.</li> 
                <li>The assumed substrate for the mounting panel's system is metal stud. For cast concrete/ concrete block substrate an ad applies.</li>
                <li>Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer in the <mark>City of Toronto</mark>.</li>
                <li>Delivery and packing, crating <mark>FOB to job site.</mark></li> 
                <li>All work to be performed during regular working hours with non-union labor forces. Any additional work to be billed based on time and material basis at $145/hour.</li>
                <li>All work to be performed uninterrupted and based on safe work practice. </li>
                <li>In the event of conflicting/missing drawings/information, a scope review/agreement will be required before proceeding with an order. We will be pleased to finalize our price (if necessary) once the scope is agreed upon. </li>
                <li>Based on one production run. If additional production is required due to customer phasing, an addition applies and will result in price being re-estimated. </li>
                <li>Based on one mobilization. If additional mobilizations are required due to customer phasing, an addition applies.</li>
              </ul>`
    },
    {
      id: 'project_exclusions',
      label: 'Exclusions',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: `<ul>
                <li>Any and all areas that are not highlighted on drawings. This proposal is based on Sq.Ft, any changes in material take off will result in re-estimating the project. </li>
                <li>Cutting and patching of slab edges. </li>
                <li>Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.</li>
                <li>Window sill flashing.</li>
                <li>Thru-wall or counter flashings.</li>
                <li>Roofing membrane. Any cap flashing at interface with roofing and structure.</li>
                <li>Spray or liquid applied air or air/vapour barrier. </li>
                <li>Spray applied insulation systems.</li>
                <li>Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).</li>
                <li>Installation of wood backing or blocking.</li>
                <li>All hoarding permits and public protection not included.</li>
                <li>Installation of any exterior lighting, and all other electrical components. Removal of any items. </li>
                <li>Penetrations required in the panel system for signage, lighting, etc., must be cut on-site as required at $145/hour.</li>
                <li>Supply and installation of any signage and provision to accommodate the same.</li>
                <li>Painted fasteners.</li>
                <li>Attic stock.</li>
                <li>Perimeter foaming.</li>
                <li>Performance mock-up.</li>
                <li>Smoke seal.</li>
                <li>Acoustic sealants.</li>
                <li>Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.</li>
                <li>Supply of exhaust boxes and vents. Connection of any mechanical components. </li>
                <li>Any / all Structural anchors and fasteners.</li>
                <li>Substrate framing, structural supports and metal stud framing, structural steel framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8" will be considered as a structural component.</li>
                <li>Costs associated with use of the material hoist and crane.</li>
                <li>Construction of or supply of spray racks, chambers, water supply or any other material for field testing.</li>
                <li>Any permits, licenses and certificates.</li>
                <li>Final cleaning of Panel, including removal of stickers/labels, and protective films.</li>
              </ul>
      `
    },
    {
      id: 'proposal_validity',
      label: 'Proposal Validity',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      value: 'The proposal is valid for <mark>thirty (30)</mark> days.'
    }
  ],
  proposal_content: [
    {
      id: 'material_and_installation',
      name: 'Material Selection and Installation Details',
      type: 'static',
      visible: true,
      subsections: [
        {
          id: 'materials',
          label: 'Materials',
          f_component: 'VDynamicList',
          d_component: 'DynamicMaterials',
          f_bind: { hasAddButton: true, hasDeleteButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'material',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Material'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Material description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: [
            {
              material: 'material 1',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              },
              visible: true
            },
            {
              material: 'material 2',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              },
              visible: true
            }
          ]
        },
        {
          id: 'additional_materials',
          label: 'Additional Materials',
          f_component: 'VDynamicList',
          d_component: 'DynamicMaterials',
          f_bind: { hasAddButton: true, hasDeleteButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'material',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Material'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Material description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: []
        },
        {
          id: 'install_method',
          label: 'Installation Method',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: { hasAddButton: true, hasDeleteButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'method',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Installation method title'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Installation method description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: [
            {
              id: null,
              method: 'method 1',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            }
          ]
        },
        {
          label: 'Detailed Installation Method',
          id: 'install_method_detailed',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: { hasAddButton: true },
          d_bind: { class: 'break-after' },
          template: [
            {
              label: 'method',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Installation method title'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Installation method description',
                counter: true,
                counterValue: 160
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            },
            {
              label: 'visible',
              default: true
            }
          ],
          value: []
        },
        {
          id: 'drawing_highlight',
          label: 'Drawing Highlights',
          f_component: 'VDynamicList',
          d_component: 'VSubsection',
          f_bind: { hasAddButton: true, hasDeleteButton: true },
          template: [
            {
              label: 'elevation',
              component: 'VTextField',
              tag: 'h3',
              bind: {
                placeholder: 'Drawing highlight title'
              },
              default: ''
            },
            {
              label: 'text',
              component: 'VTextField',
              tag: 'p',
              bind: {
                placeholder: 'Drawing highlight description'
              },
              default: ''
            },
            {
              label: 'image',
              component: 'VFileUpload',
              tag: 'img',
              display_class: "drawing-highlight",
              bind: {
                hasName: true
              },
              default: {
                file: '',
                name: '',
                url: ''
              }
            }
          ],
          value: [
            {
              id: null,
              elevation: 'North Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            },
            {
              id: null,
              elevation: 'South Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            },
            {
              id: null,
              elevation: 'East Elevation',
              text: '',
              image: {
                file: '',
                name: 'file_placeholder.png',
                url: 'https://bulma.io/assets/images/placeholders/800x480.png'
              }
            }
          ]
        }
      ]
    },
    {
      id: 'pricing_summary',
      name: 'Pricing Summary',
      type: 'dynamicSubsections',
      visible: true,
      subsection_template: [
        {
          label: 'title',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Pricing summary section title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Pricing summary section description',
            counter: true,
            counterValue: 160
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: '',
          }
        }
      ],
      subsections: []
    },
    {
      id: 'detailed_pricing',
      name: 'Detailed Pricing',
      type: 'dynamicSubsections',
      visible: true,
      subsection_template: [
        {
          label: 'title',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Detailed pricing section title'
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          display_class: 'detailed-pricing',
          bind: {
            hasName: true,
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Detailed pricing section description',
            counter: true,
            counterValue: 160
          },
          default: ''
        }
      ],
      subsections: [
        {
          title: 'Detailed Pricing 1',
          text: '',
          image: {
            file: '',
            name: '',
            url: ''
          }
        }
      ]
    },
    {
      id: 'past_projects_one',  
      name: 'Past Projects (1)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsOne'
    },
    {
      id: 'past_projects_two',  
      name: 'Past Projects (2)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsTwo'
    },
    {
      id: 'past_projects_three',  
      name: 'Past Projects (3)',
      type: 'optional',
      visible: true,
      component: 'PastProjectsThree'
    },
    {
      id: 'general_tos',  
      name: 'Qualifications',
      type: 'static',
      visible: true,
      subsections: [
        {
          id: 'terms_purchase',
          label: 'Terms of Purchase',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>This offer is valid for <mark>30 days</mark>.</li>
                    <li>
                      This offer is made with the understanding that a pre-award meeting will include a design review and mutual acceptance of the scope of work, contract documents, schedule and terms and conditions prior to finalizing an agreement.
                      <ul>
                        <li>An agreement to be concluded between Mitrex and the customer at the earliest of issuing an order confirmation by Mitrex.</li>
                      </ul>
                    </li>
                    <li>Any changes from the plans or specifications involving additional costs shall be executed only upon signed written change orders and will be an extra charge over and above the price of this proposal on an item-by-item basis or completed on a time and material basis.</li>
                    <li>Holdback to be released 45 days after substantial completion of panel installation as per completed area.</li>
                    <li>Holdback to be released 45 days after substantial completion of the production phase.</li>
                    <li>30% Deposit payment is required. No project shall commence until the deposit has been made and contract has been confirmed.</li>
                    <li>Payments to Cladify are not contingent upon the Contractor or Owner being paid by Owner and/or Lender. No contingency of paying will be acceptable. </li>
                    <li>Price based on non-union labour.</li>
                    <li>No return, exchange or refund policy applies to all custom-made products.</li>
                    <li>Proposal is based on Sq.Ft area, any addition on the estimated area will result in price being re-estimated. </li>
                    <li>All estimates are subject to site delivery and the final invoice is based on total delivered products.</li>
                    <li>All delivered products are the property of Cladify Inc. until fully paid by the customer.</li>
                    <li>The price stated in the order shall be the base price for the products and does not include value added taxes. And all amounts to be paid in full and without any deduction.</li>
                    <li>Unless otherwise agreed in writing, any invoice shall be due and payable within 30 calendar days of the date of such invoice.</li>
                    <li>2% per month (24% per annum) charged on overdue accounts, this rate will apply both before and after any adjustment that may be obtained for a nonpayment.</li>
                    <li>Cladify Inc. can exercise the right to cancel the production slot or all previously agreed upon timelines due to nonpayment/late payments. When payment is received, it is at the discretion of Cladify Inc. to provide a revised delivery timeline. Cladify Inc. is not responsible for any project delays or issues as a result of nonpayment/late payment.</li>
                    <li>Cladify Inc. can exercise the right to move produced products to a third party storage facility in the event of nonpayments/late payments. Cladify Inc. can charge $85 per day, per skid, A-frame or L-frame, and an additional $1,000 of logistics costs until payment is cleared.  </li>
                    <li>Cladify Inc. can exercise the right to demobilize the installation team due to nonpayment/late payments of over 30 days in the installation phase. Cladify Inc. can charge the cost of demobilization to the customer, at a flat rate of $15,000. The project timeline will then be renegotiated according to the delays as a result of nonpayment/late payments.</li>
                    <li>Cost of any bonding (performance and labor/material payment bonds and other insurances) is excluded.</li>
                    <li>No liquidated or consequential damages.</li>
                    <li>No waivers of Subrogation or Severability of Interest clauses.</li>
                    <li>Upon acceptance, this quotation is or becomes part of the legal contract documents.</li>
                    <li>All extra contract hours performed must be signed off by an authorized Owner Representative.</li>
                    <li>All approved extra to contract time and material charges will be billed on the next billing.</li>
                    {PAYMENT_INSTRUCTION_INSTALL}
                  </ul>`
        },
        {
          id: 'terms_delivery',
          label: 'Delivery Terms',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>This proposal is based on a <mark>Q1 2023</mark> production date.</li>
                    <li>Schedule of work and manufacturing schedule to be mutually agreed upon by the Client and Cladify Inc.</li>
                    <li>In the event that the construction schedule is delayed by no fault of the Subcontractor, the Subcontractor will incur storage costs relating to product built in accordance with the construction schedule. Such costs will be billed back to the Owner in the form of a change order.</li>
                    <li>Cladify company cannot be responsible for delays due to any unforeseen impediments beyond its control, like strikes, boycotts, lockouts, fires, war, embargos and delay in receiving of raw material.</li>
                    <li>Shop drawing submission date to be agreed to prior to award. Complete issued for construction CAD drawings is required prior to commencement.</li>
                    <li>Shop drawings and other related documents to be submitted in English.</li>
                    <li>Schedule will be weather permitting and no penalties for slow previous trades.</li>
                    <li>First delivery of panels will be on site the greater of <mark>20-24</mark> weeks after final approval of shop drawings or mutually agreed upon schedule.</li>
                  </ul>`
        },
        {
          id: 'acceptable_tolerances',
          label: 'Acceptable Tolerances/ System Requirements',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>Re-design of some details required.</li>
                    <li>Overall R-values, condensation values, and all other performance criteria to be determined by final design. At this point, Cladify has not considered thermal and structural requirements that can affect the pricing. </li>
                    <li>Due to material limitations, some panels/details may require added joints and/or detail modifications.</li>
                    <li>Quoted system to follow Cladify standard detailing, depth system requirements, specifications and product fabrication procedures. System details available on request.</li>
                    <li>We cannot guarantee visual flatness of Cladify panels. Visual flatness under all conditions is a subjective measure. Cladify panels shall be fabricated in a workmanlike manner to provide maximum deviation from flat of 1/8" based on L/240. Acceptance/rejection shall be based on objective measurements, not subjective visual observations.</li>
                    <li>System joints including panel to panel, vertical and horizontal, and panel to panel alignment tolerance +-¼".  Cladify panel to other materials +-1/2". Cladify panel to windows/doors and other penetrations +-1-1/2".</li>
                    <li>Elastic deflection limits for panels to be L/240 + ¼" for spans greater than 40".</li>
                    <li>Maximum sheet size of Cladify panels is 48" x 96". Any panels exceeding these limits will have joints added.</li>
                    <li>It is understood that due to the nature of panel systems, special care must be taken to have floor slabs as level as possible. Both parties must agree on a tolerance before entering into an agreement.</li>
                    <li>Proper structure is required at all anchoring locations.</li>
                    <li>Products except where otherwise noted will be furnished according to CTS (Cladify Technical Specification).</li>
                    <li>Cladify panels with Natural Stone Facing are subject to variations in color, markings and texture. Color variations, veining, shadings, marking are inevitable. </li>
                    <li>Any samples are approximations only. Samples to be agreed by both parties prior to order.</li>
                    <li>Imperfections are to be corrected using Cladify Technical Specification (CTS).</li>
                    <li>Wall substrate to be plumb, true and acceptable to standard construction tolerances prior to installation of exterior wall panels.</li>
                    <li>Extra cost may apply for excessive wall adjustments. Acceptable tolerances for Cladify system is maximum 3/8".</li>
                    <li>All thermal performance requirements are based on average project sizes.</li>
                    <li>All columns and shear walls must be a minimum within acceptable tolerances +- ⅜" every 120", true, level and plumb.</li>
                    <li>All penetrations made by others through the panel system are the responsibility of others to seal.</li>
                    <li>We are not responsible for components of other scopes that may be deemed "Climbable". It is the architect's responsibility to flag any components that may be deemed "Climbable". All remedies on site to accommodate anti-climbing will be charged extra to the contract.</li>
                    <li>All products will conform to building codes.</li>
                  </ul>`
        },
        {
          id: 'warranty',
          label: 'Warranty',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>7-year material warranty on all defects from manufacturing, and <mark>2-year labour warranty</mark>.</li>
                    <li>Upon product arrival, it's up to the customer to inspect their condition, nature and their compliance with the order and inform Cladify of any compliance in writing within 3 days of receipt of the products. Cladify warrants to re-supply such defective material only as brought to their attention; material placed on the wall shall constitute product acceptance.</li>
                    <li>Extended and other special warranties are excluded.</li>
                    <li>Panel will be replaced during the course of construction if it is determined to be a cause of faulty manufacturing. In the case it is broken due to other circumstances, the owner will pay to replace the affected panels and components.</li>
                  </ul>`
        },
        {
          id: 'miscellaneous',
          label: 'Miscellaneous',
          f_component: 'VRichText',
          d_component: 'VRichTextRenderer',
          value: `<ul>
                    <li>Any drawing, catalogue or technical literature sent to the customer before and after termination of order remains Cladify Inc. exclusive property and cannot be copied, reproduced, transmitted or notified to third parties without prior consent in writing from Cladify, as strictly confidential.</li>
                    <li>Our proposal is based on the responsibility for the protection of our material after acceptance to be borne by the owner and/or General Contractor.</li>
                  </ul>`
        }
      ]
    },
    {
      name: 'Last Page',
      type: 'optional',
      visible: true,
      component: 'LastPage',
      bind: {
        productBrand: 'Cladify'
      }
    }
    // {
    //   name: 'Warrantees & Guarantees',
    //   type: 'optional',
    //   visible: false,
    //   component: 'div'
    // }
  ]
}
